import join from "lodash/join";
import sortBy from "lodash/sortBy";
import actionTypes from "./actionTypes";
import api from "./api";
export default {
    toggleTasksLogsResult: (show, sourceTaskIds, title) => ({
        type: actionTypes.TOGGLE_TASKS_LOGS_RESULTS,
        show,
        sourceTaskIds,
        title
    }),
    getTasksLogs: (sourceTaskIds, completed, rejected) => ({
        type: actionTypes.GET_TASKS_LOGS,
        payload: {
            promise: () => api.getTasksLogs(sourceTaskIds)
        },
        scope: `${actionTypes.GET_TASKS_LOGS}_${join(sortBy(sourceTaskIds), "_")}`,
        completed: (_, { payload }) => {
            completed && completed(payload);
        },
        rejected: () => {
            rejected && rejected();
        }
    })
};
